<template>
  <div class="customise-item" style="display: block">
    <div class="customise-item-details">
      <div
        class="extra-items-wrapper"
        :class="toggleRollInto ? 'rollinto' : ''"
      >

<!--        Todo make this full width for sushi-->
        <div
          v-if="!toggleRollInto && !isSushi"
          ref="headerImg"
          v-show="product.PhotoUrl"
          :style="getImageStyle"
          class="modalImage w-100"

        />
        <img
          v-if="!toggleRollInto"
          v-show="isSushi"
          :src="product.PhotoUrl"
          @error="imgHttpError"
          alt="productImage"
          :class="isSushi && 'sushi-add-cart-img'"
        />
        <div
          class="container "
          :class="isSushi ? 'item-details-sushi' : 'item-details'"
          :style="getModifiersContainerStyle"
        >
          <div class="row" v-if="!toggleRollInto">
            <div class="col-12">
              <h3 :class="isSushi ? 'montserrat-700 mt-5' : 'text-center' ">{{ getProductName() }}</h3>
              <p :class="isSushi ? 'montserrat-500 s-description-sushi' : 's-description text-center'"
                v-html="getProductDescription()"
              ></p>
            </div>
            <div class="w-100 pt-2 "   :class="isSushi ? 'montserrat-700 container ' : 'text-center'">
              <h3 v-if="price > 0"  >{{ price | formatMoney(currencySign) }}</h3>
              <h3 v-if="getBasePoints" class="ml-2 text-success">
                ({{ getBasePoints | formatNumber }} pts)
              </h3>
            </div>
            <div
              v-if="!isDigitalDisplay"
              class="w-100 mt-3 pb-1 d-flex "
              :class="isSushi? 'container' : ' justify-content-center'"
            >
              <button
                :disabled="quantity <= 1"
                class="btn-white btn-circle d-flex justify-content-center align-items-center"
                :style="mobileStyles.CommonColorTxt"
                @click="dec"
              >
                <span class="material-icons bigger-material-icons px-2"
                  >{{ isSushi ? 'remove'  : 'remove_circle_outline' }}</span
                >
              </button>
              <span class="d-flex px-3 align-items-center">
                <strong :class="isSushi && 'montserrat-700'" >{{ quantity }}</strong>
              </span>
              <button
                class="btn-white btn-circle d-flex justify-content-center align-items-center"
                :class="isSushi && 'color-sushi'"
                :style="mobileStyles.CommonColorTxt"
                @click="inc"
              >
                <span class="material-icons bigger-material-icons" :class="'color-sushi'"
                  >{{ isSushi ? 'add'  : 'add_circle_outline' }}</span
                >
              </button>
            </div>
          </div>
          <div v-show="!toggleRollInto" class="mt-3">
            <Modifiers
              @showSubmodifier="customizeSubmodifier"
              :product="product"
              :modifiers="modifiers"
              :is-submodifier="toggleRollInto"
              :modifier-groups-states="ModifierGroupsStates"
              ref="modifiersRefs"
              :isSushi="isSushi"
            />
            <div v-if="showRollIntoProduct" class="container mb-2">
              <div class="row">
                <a
                  v-if="selectedRollIntoModiefiers.length == 0"
                  :style="mobileStyles.roolIntoButton"
                  @click="toggleRollInto = true"
                >
                  <div class="roll-into-items">
                    <div class="roll-item-details">
                      <div class="roll-item-details-name">
                        {{ showRollIntoProduct.Name }}
                      </div>
                    </div>
                    <div
                      v-if="getRollIntoPoints"
                      class="roll-item-point-addtocart"
                    >
                      ({{ getRollIntoPoints | formatNumber }} pts)
                    </div>
                    <div
                      :class="getRollIntoPoints ? 'has-point' : ''"
                      class="roll-item-cost"
                    >
                      {{ showRollIntoProduct.FixedPriceValue | formatMoney(currencySign) }}
                    </div>
                  </div>
                </a>
                <a v-else class="w-100" @click="enableRollInto">
                  <div
                    v-if="selectedRollIntoModiefiers.length > 0"
                    :style="mobileStyles.roolIntoButton"
                    class="h-100"
                  >
                    <div class="roll-into-items">
                      <div class="roll-item-details">
                        <div class="roll-item-details-name">
                          {{ showRollIntoProduct.Name }}
                        </div>
                        <ul>
                          <li
                            v-for="md in selectedRollIntoModiefiers"
                            :key="md.ID"
                            :style="mobileStyles.primaryColor"
                          >
                            {{ md.Name }} ({{ md.quantity }})
                          </li>
                        </ul>
                      </div>
                      <div
                        v-if="getRollIntoPoints"
                        class="roll-item-point-addtocart selected"
                      >
                        ({{ getRollIntoPoints | formatNumber }} pts)
                      </div>
                      <div
                        :class="getRollIntoPoints ? 'has-point' : ''"
                        class="roll-item-cost"
                      >
                        {{ rollIntoPrice | formatMoney(currencySign) }}
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <div class="w-100 mb-2" v-show="viewConfig.ShowNotesForItem">
              <div>
                <h4>{{ $t("message.notes") }}</h4>
                <textarea
                  id="notes"
                  maxlength="300"
                  v-model="itemNote"
                  name="notes"
                  type="text"
                  class="form-control"
                />
              </div>
            </div>
          </div>
          <div v-show="toggleRollInto">
            <Modifiers
              v-if="toggleRollInto"
              :price-trigger="showRollIntoProduct"
              @canceled="cancelSubModifier"
              :product="rollIntoParams.product"
              :modifiers="rollIntoParams.modifiers"
              :product-id="rollIntoParams.productId"
              @updated="selectRollIntoModiefiers"
              :is-submodifier="toggleRollInto"
              :initial-modifiers="rollIntoParams.initModifiers"
              :has-confirm-button="true"
              :selected-modifier="rollIntoParams.selectedModifier"
            />
          </div>
        </div>
      </div>
      <footer class="extras-footer" v-if="!toggleRollInto">
        <button
          type="button"
          class="btn"
          :class="[isDigitalDisplay ? 'w-100' : '', isSushi ? 'montserrat-500 background-sushi-cancel text-white' : 'btn-cancel']"
          :style="isSushi?  mobileStyles.sushiBtn  : mobileStyles.btn"
          @click="closeModalMobile()"
        >
          {{$t("message.cancel") }}
        </button>
        <button
          type="button"
          class="btn btn-primary"
          style="opacity: 0.85"
          v-if="!isDigitalDisplay"
          :style="mobileStyles.btn"
          :disabled="isDisabledAddCards"
          @click="addToCartMobile()"
          :class="isSushi && 'montserrat-700 curved-10 background-sushi'"
        >
          <span style="float: left"  :class="isSushi && 'montserrat-700'" >
            {{ $t("message.addToCart") }}
          </span>
          <span
            style="float: right; margin-right: 2px"

            >{{ totalPrice | formatMoney(currencySign) }}</span
          >
          <!-- <span v-else style="float: right">
            {{ $t("message.maximumQuantityExceeded") }}
          </span> -->
        </button>
      </footer>
    </div>
  </div>
</template>

<style>
.background-sushi {
  background-color: #F04653;
}
</style>

<script>
import shared from "../../../sharedscripts/shop/products/AddToCart.js";
import sharedTranslations from "../../../sharedscripts/shop/products/Translations";
import Modifiers from "./Modifiers";
import { mapGetters, mapMutations } from "vuex";
import { scrollModify } from "../../../api/helpers/uiHelper";
export default {
  name: "AddToCartMobile",
  components: { Modifiers },
  props: {
    category: {
      type: Object,
      default: () => {},
    },
    parentCategory: {
      type: Object,
      default: () => {},
    },
    product: {
      type: Object,
      default: () => {},
    },
    modifiers: {
      type: Object,
      default: () => {},
    },
    price: {
      type: Number,
      default: 0,
    },
    productId: {
      type: Number,
      default: 0,
    },
    imageStyles: {
      type: Array,
      default: () => [],
    },

  },
  // watch: {
  //   // ModifierGroupsStates: {
  //   //   handler: function() {
  //   //     this.checkMaximumSelection();
  //   //     this.checkMinimumSelection();
  //   //   },
  //   //   deep: true
  //   // }
  // },
  data() {
    return {
      quantity: 1,
      // maxItemQuantity: 20,
      selectedModifiers: [],
      ModifierGroupsStates: [],
      toggleRollInto: false,
      selectedRollIntoModiefiers: [],
      itemNote: "",
      selectedModifierForCustomize: null,
      forceUpdate: false,
    };
  },
  mounted() {
    scrollModify(true);
  },

  computed: {
    ...mapGetters([
      "viewConfig",
      "mobileStyles",
      "canshowRollInto",
      "storeMenu",
      "hqDoc",
      "isDigitalDisplay",
    ]),
    ...shared.computed,
    getModifiersContainerStyle() {
      var style = [];
      if (this.toggleRollInto) {
        style.push({ height: "calc(100vh - 175px)" });
        style.push({ "overflow-y": "auto" });
        style.push({ "margin-bottom": "50px" });
      }
      return style;
    },
    showRollIntoProduct() {
      return this.canshowRollInto(
        { ...this.product, quantity: this.quantity },
        this.quantity
      );
    },
    menuCopy() {
      return JSON.parse(JSON.stringify(this.storeMenu));
    },
    rollIntoParams() {
      if (this.selectedModifierForCustomize)
        return {
          product: this.menuCopy.Products[
            this.selectedModifierForCustomize.LinkedProductID
          ],
          modifiers: JSON.parse(JSON.stringify(this.menuCopy.ModifierGroups)),
          productId: this.selectedModifierForCustomize.LinkedProductID,
          initModifiers: this.selectedModifierForCustomize.selectedSubmodifiers,
          selectedModifier: this.selectedModifierForCustomize,
        };
      else if (this.showRollIntoProduct)
        return {
          product: this.menuCopy.Products[this.showRollIntoProduct.ProductID],
          modifiers: this.menuCopy.ModifierGroups,
          productId: this.showRollIntoProduct.ProductID,
        };
      else return {};
    },
    rollIntoPrice() {
      var result = 0;
      this.selectedRollIntoModiefiers.forEach((element) => {
        result += element.Price;
      });
      return this.showRollIntoProduct
        ? this.showRollIntoProduct.FixedPriceValue
        : 0 + result;
    },

    isSushi() {
      return   this.hqDoc && this.hqDoc.IsSushiHub
    }
  },
  methods: {
    ...mapMutations(["confirmRollInto"]),
    ...shared.methods,
    ...sharedTranslations.methods,
    getStyle(isChecked) {
      var style = [];
      if (isChecked) {
        style.push(this.mobileStyles.CommonColorBackground);
      } else {
        style.push({
          "background-color": `rgb(255, 255, 255) !important`,
        });
      }
      return style;
    },
    cancelSubModifier() {
      this.toggleRollInto = false;
      scrollModify(true);
    },
    enableRollInto() {
      this.toggleRollInto = true;
      scrollModify(true);
    },
  },
};
</script>
